
<div class="container">
  <div *ngIf="documentNotFound" class="mt-5">
    <adp-label labelKey="Global_Document_Not_Found"></adp-label>
  </div>
</div>
